import { Overrides } from '@material-ui/core/styles/overrides';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';

export const radioOverrides: Overrides = {
  MuiRadio: {
    root: {},

    colorSecondary: {
      color: CORPORATE_COLORS.BACKGROUND_LIGHT_PRIMARY_MAX,
      backgroundColor: CORPORATE_COLORS.WHITE,
      padding: 0,
      margin: '9px',

      '&$checked': {
        color: CORPORATE_COLORS.PRIMARY,
        backgroundColor: CORPORATE_COLORS.WHITE,

        '&:hover': {
          backgroundColor: CORPORATE_COLORS.WHITE
        }
      },

      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  },

  MuiFormControlLabel: {
    label: {
      color: CORPORATE_COLORS.TEXT_PRIMARY,
      fontSize: '16px'
    }
  }
};
